exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IHqc1QGp3HQPfF ._6XszeBH00nGVni{width:100%;margin-bottom:8px}._3KQHSTrtmaNJqU{margin-top:8px;margin-bottom:0}", ""]);

// exports
exports.locals = {
	"createTeam": "IHqc1QGp3HQPfF",
	"createTeamInput": "_6XszeBH00nGVni",
	"createTeamButton": "_3KQHSTrtmaNJqU"
};